module.exports = __webpack_public_path__ + "img/gift-6.9be16e6e.jpg";